import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {DropzoneArea} from 'material-ui-dropzone'
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';

import { makeStyles } from '@mui/styles'; 


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  AddSchedulebox extends Component {

  constructor(props) {
	   super(props)
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	  this.state = {staffid:'',erropen:false,errormessage:'',alertype:"error",slotid:'',durationid:'',open:false, stsdate:Date.now(),stsdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),classtype:'1',lcid:'',custid:'0',subscribeData:[],slotData:[],custdata:[],ispanel:false,staffarray:[],slotdisable:false,cuname:'',staff:'',cuid:0}
  }
    handleClickClose= (e) => { this.setState({open:!this.state.open,}); }
   handleClickOpen = (e) => {
	 
	
	  var date = new Date(this.props.celldate);
	  
	   var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
	 var strcls="";
	 if(this.props.eclstyp==="1")
		{
			strcls="3";
		}
	 else if(this.props.eclstyp==="6")
		{
			strcls="6";
		}
	
     this.setState({ stsdate:dayjs(date),lcid:strcls,classtype:this.props.eclstyp,staffdisable:false,btnSaveStaff:'Save',
stsdate1:this.props.celldate,cuname:this.props.orname,slotid:this.props.slotname,ispanel: false,cuid:this.props.eorcuid	 ,open:!this.state.open,slotid:'',staff:'',custid:this.props.eorid},()=>{this.onloadslot();this.onloadStaffbind();	});
	    
	   
	  if(this.props.id!="0")
	  {
		 
	  this.onloadStaffschedulebind();
	  }
	   }
	   
	txtchange = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val},()=>{
	  
	  if(nam==="slotid" && (this.state.classtype==="1" || this.state.classtype==="2"|| this.state.classtype==="6"))
	  {

		 this.onloadCustomer(); 
	  }else if(nam==="custid")
	  {let strarr=val.split('~');
		 this.setState({custid: strarr[0],cuid:strarr[1]} );
	  }
	  
  });
  } 
    handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ stsdate:dayjs(date),
stsdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }   
onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3')    
    .then((response) => {    
		this.setState({  staffarray: response.data,  },()=>{
			let roleFromApi = this.state.staffarray.map(st => {
			return {value: st.st_id, display:st.st_name}
			});
			this.setState({staffarray: [{value: '', display: 'All'}].concat(roleFromApi) });
		});
    })   
}

onloadStaffschedulebind(){

    axios.get(Serverurl+'ajaxstaffschedule.php?action=list&sts_id='+this.props.id)    
    .then((resp) => { 

	 if(resp.data.length>0){
		 let strdisable=false;
		 if(resp.data[0]["cs_or_id"]!=="0")
		 {
			 strdisable=true;
		 }
	 this.setState({slotid:resp.data[0]["sts_sm_id"],slotdisable:strdisable},()=>{
		 this.onloadslot();
		 this.setState({  stsdate:resp.data[0]["start"],stsdate1:resp.data[0]["date"],
		lcid:resp.data[0]["sts_lc_id"],classtype:resp.data[0]["sts_classtype"],
		staff:resp.data[0]["sts_st_id"],slotid:resp.data[0]["sts_sm_id"],custid:resp.data[0]["cs_or_id"],cuid:resp.data[0]["or_cu_id"]
		},()=>{this.onloadCustomer();});
	 });
		 
		 
		
		
	 }
    })   
}
onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({classtype: event.target.value},()=>{ this.onloadslot();
		
		
		 });
	}
	
	onChangelocation = (event: React.ChangeEvent<HTMLInputElement>) => {
		var strcls="";
		
		if(event.target.value==="3")
		{
			strcls="1";
		}
	else if(event.target.value==="2")
		{
			strcls="2";
		}
		else if(event.target.value==="1")
		{
			strcls="2";
		}
		
		 this.setState({lcid: event.target.value},()=>{
		 
			 
			 
		 });
	}
	
onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getall&sm_slottype='+this.state.classtype+'&sorting=sm_order&sm_bm_id='+this.props.brid)
  .then(resp => {  
		
  if(resp.data.length>0){				
		this.setState({slotData:resp.data},()=>{
			let slotApi = this.state.slotData.map(row => {                          
          return {value:row.sm_id,display:row.sm_slotname}
        });     
		
        this.setState({slotid:this.props.slotname,
          slotData: [{value: '0', display:'Select Slot'}].concat(slotApi)
        });
								
		})
	
		}else{this.setState({slotData:[]});
		 }
 
    });
		
	}
	onloadCustomer(){
		
		axios.post(Serverurl+'ajaxorders.php?action=getactiveorders&slotid='+this.state.slotid+'&date='+this.state.stsdate1)
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({ ispanel: true,
						custdata:resp.data	
							},()=>{
								
								
								 let custApi = this.state.custdata.map(row => {
                          
          return {value:row.or_id+"~"+row.or_cu_id,display:row.or_name}
        });
      
		
        this.setState({
          custdata: [{value: '0', display:'Select Customers'}].concat(custApi)
        });
								
							})

	
			}else{
				this.setState({custdata:[],ispanel: false,});
			}
 
    });
		
	}
handleSave = (e) => {

let stsdate1 = this.state.stsdate1;
let classtype = this.state.classtype;
let lcid = this.state.lcid;
let slotid = this.state.slotid;	

let staff = this.state.staff;
let custid = this.state.custid;	

let cuid = this.state.cuid;	
if(stsdate1==="")
{
	
	this.setState({errormessage:"Please Enter Date",erropen:true});
	window.scrollTo({top: 0})
		 return false;
	
	
}
if(lcid==="")
{ 
this.setState({errormessage:"Please Select Location",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
	
}
if(classtype==="")
{
	
	this.setState({errormessage:"Please Select Preference",erropen:true});
		 window.scrollTo({      top: 0    })
		 return false;
	
	
}

if(slotid==="")
{
	
	this.setState({errormessage:"Please Select Slot",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
		
}
if(staff==="")
{
	
	this.setState({errormessage:"Please Select Staff",erropen:true});
		 window.scrollTo({  top: 0  })
		 return false;
		
}
if(slotid!=="" && (this.state.classtype==="1" || this.state.classtype==="2"))
	  {

	  }
	 	this.setState({errormessage:"",erropen:false,staffdisable:true,btnSaveStaff:'Processing...',}); 

 var formData = new FormData();
 
 if(this.props.id==="0")
 {
formData.append('action','insert') 
 }
 else{
	formData.append('action','update')  
	formData.append('sts_id',this.props.id)
 }
formData.append('sts_st_id',staff)
 formData.append('sts_sm_id',slotid)
 formData.append('sts_classtype',classtype)
  formData.append('sts_lc_id',lcid)
    formData.append('sts_date',stsdate1)
		formData.append('cs_id',custid)
		formData.append('cuid',cuid)
		
	formData.append('userid',localStorage.getItem("AYLuserid"))
	axios.post(Serverurl+"ajaxstaffschedule.php", formData, {
        }).then(res => {
			
			if(res.data ===-1)
{ 

this.setState({errormessage:"please select another Satff",erropen:true,staffdisable:false,btnSaveStaff:'Save',});
}
				else if(res.data ===0)
{ 
	this.setState({errormessage:"Already Scheduled, please select another slot",erropen:true,staffdisable:false,btnSaveStaff:'Save',});		
}else{
	this.setState({errormessage:"Staff Scheduled Successfully",erropen:false,open:false,classtype:'1',staffdisable:false,btnSaveStaff:'Save',slotid:'',subid:'',staff:'',custid:'0'},()=>{this.props.updateDonenew();});
		 window.scrollTo({  top: 0  })

}	
		});
};

render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xl" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  Schedule for {this.state.cuname}
	  </DialogTitle>
      <DialogContent>
	  <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  <div className="scheduelpop">
	  <ul>
	  <li>
	  
	  <p><span className="validation">*</span> Date
		</p>
	<p>
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.stsdate) }
className="txtbox" minDate={dayjs(Date.now()) }
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	</p>
	  </li>
	  {this.props.eclstyp==="2" && (
<li>
<p><span className="validation">*</span>Select  Location</p>

<FormControl className="location">
  
      <RadioGroup  value={this.state.lcid}
        defaultValue={this.state.lcid}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangelocation}
      >
	  
      
        <FormControlLabel value="4" control={<Radio />} label="Personal Training Studio " />
        
        <FormControlLabel value="1" control={<Radio />} label="Personal Training Room 01 " />
		<FormControlLabel value="2" control={<Radio />} label="Personal Training Room 02 " />
      </RadioGroup>
    </FormControl>

</li>
	  )}

<li>
<p><span className="validation">*</span> Select Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select 
			 className="txtbox" 
			native
			value={this.state.slotid}
			onChange={this.txtchange}
			name='slotid'
			
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
<li><p><span className="validation">*</span> Select Staff</p>
<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.staff }}
          onChange={this.txtchange}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
</li>
{this.state.ispanel===true &&
(
<li>
<p><span className="validation">*</span> Select Customers</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.custid}
			onChange={this.txtchange}
			name='custid'
			
			fullwidth
			
			
			>
		
		
			{this.state.custdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
)}

</ul>

		
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickClose}  className="frmthirdbtn">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleSave}  disable={this.state.staffdisable} className="frmSecondarybtn">
          	{this.state.btnSaveStaff}
        </Button>
		</div></div>
<div className="clear"></div>	</div>
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 





